<script lang="ts">
    import { silentStore } from "../../Stores/MediaStore";
    import { gameManager } from "../../Phaser/Game/GameManager";
    import { chatVisibilityStore } from "../../Stores/ChatStore";
    import type { RightMenuItem } from "../../Stores/MenuStore";
    import { rightActionBarMenuItems } from "../../Stores/MenuStore";
    import { hideActionBarStoreBecauseOfChatBar } from "../../Chat/ChatSidebarWidthStore";
    import UserListMenuItem from "./MenuIcons/UserListMenuItem.svelte";
    import ResponsiveActionBar from "./ResponsiveActionBar.svelte";
    import VisibilityChecker from "./VisibilityChecker.svelte";
    import CloseChatMenuItem from "./MenuIcons/CloseChatMenuItem.svelte";
    import SilentBlock from "./SilentBlock.svelte";
    import AppsMenuItem from "./MenuIcons/AppsMenuItem.svelte";
    import MapSubMenu from "./MenuIcons/MapSubMenu.svelte";
    import ProfileMenuItem from "./MenuIcons/ProfileMenuItem.svelte";

    let rightDiv: HTMLDivElement;
    let actionBarWidth: number;

    const gameScene = gameManager.getCurrentGameScene();
    const showUserListButton = gameScene.room.isChatOnlineListEnabled;

    $: isSmallScreen = actionBarWidth < 640;

    function onMenuItemVisibilityChange(isVisible: boolean, button: RightMenuItem) {
        button.fallsInBurgerMenuStore.set(!isVisible);
    }
</script>

{#if !$hideActionBarStoreBecauseOfChatBar}
    <ResponsiveActionBar bind:rightDiv bind:actionBarWidth>
        {#snippet left()}
            <div class="justify-start flex-none">
                <div class="flex transition-all duration-150 z-2 gap-3" data-testid="chat-action">
                    {#if $chatVisibilityStore}
                        <CloseChatMenuItem />
                    {/if}
                    {#if !isSmallScreen}
                        <AppsMenuItem />
                        <MapSubMenu />
                    {/if}
                </div>
            </div>
        {/snippet}

        {#snippet center()}
            <div
                class="@xxs/actions:justify-center justify-end main-action pointer-events-auto min-w-32 @sm/actions:min-w-[192px] hidden @[160px]/main-layout:block"
            >
                <div
                    class="flex justify-center relative gap-1 @md/actions:gap-2 @xl/actions:gap-4 z-1 mx-1 @md/actions:mx-2 @xl/actions:mx-4"
                >
                    <div>
                        <!-- ACTION WRAPPER : CAM & MIC -->
                        <div class="group/hardware flex items-center relative">
                            {#if showUserListButton}
                                <UserListMenuItem />
                            {/if}
                        </div>
                    </div>
                </div>
                <!-- NAV : SILENT BLOCK -->
                {#if $silentStore}
                    <SilentBlock />
                {/if}
            </div>
        {/snippet}

        {#snippet right()}
            <div id="action-wrapper" class="flex flex-1 justify-end gap-1 @md/actions:gap-2 @xl/actions:gap-4">
                <div
                    class="flex-row flex-0 gap-0 mr-0 @sm/actions:mr-[8rem] @xl/actions:mr-[8rem] narrow:mr-0 hidden @[260px]/main-layout:flex"
                >
                    {#if rightDiv}
                        {#each $rightActionBarMenuItems as button, index (button.id)}
                            {@const ButtonComponent = button.component}
                            <VisibilityChecker
                                parent={rightDiv}
                                onVisibilityChange={(visibility) => onMenuItemVisibilityChange(visibility, button)}
                            >
                                <ButtonComponent
                                    {...button.props}
                                    classList={button.props.last && index !== $rightActionBarMenuItems.length - 1
                                        ? "me-1 @md/actions:me-2 @xl/actions:me-4"
                                        : ""}
                                />
                            </VisibilityChecker>
                        {/each}
                    {/if}
                </div>

                <div
                    class="justify-center items-center gap-3 flex-col md:gap-2 xl:gap-4 absolute top-1
                    @md/actions:top-2 @xl/actions:top-6 narrow:bottom-2 narrow:top-[initial] hidden @[260px]/main-layout:flex"
                >
                    <ProfileMenuItem />
                </div>
            </div>
        {/snippet}
    </ResponsiveActionBar>
{/if}
